var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      key: _vm.$store.state.base.isExpandNavigationDrawer,
      staticClass: "ma-0",
      attrs: { "no-gutters": "" },
    },
    [
      _vm.routeList.includes(_vm.$route.name)
        ? _c(
            "v-col",
            {
              class: `grey-background pt-4 pb-3 ${
                _vm.$store.state.base.isExpandNavigationDrawer
                  ? "pagination-mode"
                  : "pagination"
              }`,
            },
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "", align: "center" } },
                [
                  _c("v-col", { staticClass: "grey-300--text body-2" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.title) +
                        " " +
                        _vm._s(_vm.$fmt.integer(_vm.count)) +
                        " " +
                        _vm._s(_vm.count === 10000 ? "+" : "") +
                        " "
                    ),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "subtitle-2",
                          attrs: {
                            disabled: _vm.page === 1,
                            color: "grey-700",
                            text: "",
                            ripple: false,
                          },
                          on: { click: _vm.previous },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-0" }, [
                            _vm._v("mdi-chevron-left"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-icon",
                        {
                          staticClass: "mx-5",
                          attrs: { color: "grey-700", size: "8" },
                        },
                        [_vm._v("mdi-circle")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "subtitle-2 font-weight-medium pa-0 btnPage",
                          attrs: {
                            color: "grey-900",
                            icon: "",
                            small: "",
                            ripple: false,
                          },
                        },
                        [_vm._v(_vm._s(_vm.page))]
                      ),
                      _c(
                        "v-icon",
                        {
                          staticClass: "mx-5",
                          attrs: { color: "grey-700", size: "8 " },
                        },
                        [_vm._v("mdi-circle")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "subtitle-2",
                          attrs: {
                            disabled: _vm.disabledNext,
                            color: "grey-700",
                            text: "",
                            ripple: false,
                          },
                          on: { click: _vm.next },
                        },
                        [
                          _c("v-icon", { staticClass: "ml-0" }, [
                            _vm._v("mdi-chevron-right"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "v-col",
            {
              staticClass: "grey-background text-center mt-6 py-2 ml-n4",
              class: [
                `${
                  _vm.$route.name !== "AccountMembers"
                    ? "pagination"
                    : "paginationMember"
                }`,
              ],
              style: _vm.$store.state.base.isExpandNavigationDrawer
                ? `${
                    _vm.$route.name !== "AccountMembers"
                      ? "margin-left: -12px; width: calc(100% - 260px)"
                      : ""
                  }`
                : "",
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "subtitle-2",
                  attrs: {
                    disabled: _vm.page === 1,
                    color: "grey-700",
                    text: "",
                    ripple: false,
                  },
                  on: { click: _vm.previous },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-3", attrs: { color: "grey-700" } },
                    [_vm._v("mdi-chevron-left")]
                  ),
                  _vm._v(" Anterior "),
                ],
                1
              ),
              _c(
                "v-icon",
                {
                  staticClass: "mx-5",
                  attrs: { color: "grey-700", size: "8 " },
                },
                [_vm._v("mdi-circle")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "subtitle-2 font-weight-medium pa-0 btnPage",
                  attrs: {
                    color: "grey-900",
                    icon: "",
                    small: "",
                    ripple: false,
                  },
                },
                [_vm._v(_vm._s(_vm.page))]
              ),
              _c(
                "v-icon",
                {
                  staticClass: "mx-5",
                  attrs: { color: "grey-700", size: "8 " },
                },
                [_vm._v("mdi-circle")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "subtitle-2",
                  attrs: {
                    disabled: _vm.disabledNext || _vm.count < 20,
                    color: "grey-700",
                    text: "",
                    ripple: false,
                  },
                  on: { click: _vm.next },
                },
                [
                  _vm._v(" Siguiente "),
                  _c("v-icon", { staticClass: "ml-3" }, [
                    _vm._v("mdi-chevron-right"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }